/** Convert polar coordinates to Cartesian, centered at (cx, cy). */
export function polarToXY(cx: number, cy: number, angle: number, dist: number) {
  const rad = (angle * Math.PI) / 180
  return { x: cx + Math.cos(rad) * dist, y: cy + Math.sin(rad) * dist }
}

/**
 * Quadratic bezier path from (nx, ny) to (cx, cy) with organic curvature.
 * Curvature direction alternates based on the angle to center.
 */
export function curvedPathToCenter(
  nx: number,
  ny: number,
  cx: number,
  cy: number,
  curveFactor = 0.15,
): string {
  const dx = cx - nx
  const dy = cy - ny
  const angle = Math.atan2(dy, dx)
  const perpAngle = angle + Math.PI / 2
  const dist = Math.sqrt(dx * dx + dy * dy)
  const curvature = dist * curveFactor * (Math.sin(angle * 3) > 0 ? 1 : -1)
  const mx = nx + dx * 0.5 + Math.cos(perpAngle) * curvature
  const my = ny + dy * 0.5 + Math.sin(perpAngle) * curvature
  return `M ${nx},${ny} Q ${mx.toFixed(1)},${my.toFixed(1)} ${cx},${cy}`
}

/** Deterministic pseudo-random seed from an index. */
export function nodeSeed(i: number): number {
  return ((i * 7 + 3) % 13) / 13
}
